import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { EmptyValue } from '@/components/custom/empty-value'
import { HighlightedText } from '@/components/custom/highlighted-text'
import { TOOLTIP_DELAY_MS } from '@/constants/timing'
import { createMemoCell } from '@/lib/create-memo-cell'
import { cn } from '@/lib/utils'
import type { CellProps } from '../types'

interface CellTextProps extends CellProps<string | null | undefined> {
  /** Maximum lines before truncating */
  maxLines?: number
}

function CellTextBase({
  value,
  searchTerm,
  className,
  maxLines = 1,
}: CellTextProps) {
  if (value === null || value === undefined || value === '') {
    return <EmptyValue />
  }

  const displayValue = String(value)

  // Highlight search term if provided
  const highlightedContent = searchTerm ? (
    <HighlightedText text={displayValue} highlight={searchTerm} />
  ) : (
    displayValue
  )

  return (
    <Tooltip delayDuration={TOOLTIP_DELAY_MS}>
      <TooltipTrigger asChild>
        <span
          className={cn(
            'block truncate text-left',
            maxLines > 1 && 'line-clamp-2',
            className
          )}
        >
          {highlightedContent}
        </span>
      </TooltipTrigger>
      <TooltipContent
        side="bottom"
        className="max-w-xs break-words"
        sideOffset={4}
      >
        {displayValue}
      </TooltipContent>
    </Tooltip>
  )
}

export const CellText = createMemoCell(CellTextBase, 'CellText')
